/* wg-mm-resources.js - Wade Greens
 *
 * Rebuilds the MOBILE menu's "Resources" dropdown so it matches the desktop
 * Resources mega menu, laid out the way Klaviyo lays theirs out.
 *
 * WHY THIS IS JAVASCRIPT AND NOT CONTENT BLOCKS.
 * The mobile Resources accordion was not Resources at all - read live
 * 2026-10-01, it held nine MICROGREENS PRODUCT tiles (Alfalfa, Arugula,
 * Basil, Pak Choi, Broccoli, Cilantro, Pea Shoot, Sunflower, Wheatgrass) and
 * a view-all to /collections/microgreens. None of the 24 real Resources links
 * were in it. That content lives in config/settings_data.json, which is 70KB -
 * past what the Admin API can write - and the section that renders it,
 * sections/image-link-list.liquid, is 73.7KB, also past it. Neither file can
 * be edited from here, so the panel is rebuilt in the browser instead.
 *
 * THE CONTENT BELOW IS A SNAPSHOT of the desktop mega menu, read from the live
 * site on 2026-10-01. It does NOT follow the desktop menu automatically. If
 * the desktop Resources menu changes, this array has to change with it.
 *
 * It only ever touches the one accordion whose title is "Resources". Every
 * other tab in the mobile menu is left exactly as it is.
 */
(function () {
  'use strict';

  var GROUPS = [
    {
      label: 'Growing Guides',
      links: [
        ['Plants for Zone 7', '/collections/growing-zone-7'],
        ['Plants for Zone 8', '/collections/growing-zone-8'],
        ['Plants for Zone 9', '/collections/growing-zone-9'],
        ['Starter Plants', '/collections/starter-plants'],
        ['Sustainability & Our Process', '/pages/sustainability-our-process-wade-greens-farms'],
        ['Growing Resources', '/pages/resources']
      ],
      cta: ['Browse Growing Guides', '/blogs/growing-guide-sustainability']
    },
    {
      label: 'Fresh & Seasonal',
      links: [
        ['In Season Now', '/pages/fresh-sheet'],
        ['Farmers Markets', '/pages/farmers-markets'],
        ['News & Events', '/blogs/news'],
        ['Our Roots', '/pages/our-origins-wade-greens-farms']
      ],
      cta: ['See the Fresh Sheet', '/pages/fresh-sheet']
    },
    {
      label: 'Our Farm',
      links: [
        ['Our Roots', '/pages/our-origins-wade-greens-farms'],
        ['Sustainability & Our Process', '/pages/sustainability-our-process-wade-greens-farms'],
        ['Farmers Markets', '/pages/farmers-markets'],
        ['Contact', '/pages/contact']
      ],
      cta: ['Read Our Roots', '/pages/our-origins-wade-greens-farms']
    },
    {
      label: 'Support',
      links: [
        ['FAQ', '/pages/frequently-asked-questions-wade-greens-farms'],
        ['Shipping & Delivery', '/policies/shipping-policy'],
        ['Returns & Refunds', '/policies/refund-policy'],
        ['Your Orders', '/account'],
        ['Track Order(s)', '/account/login'],
        ['Accessibility', '/pages/ada'],
        ['Contact Support', '/pages/contact']
      ],
      cta: ['Visit Resources', '/pages/resources']
    },
    {
      label: 'Terms & Policies',
      links: [
        ['ADA', '/pages/ada'],
        ['Privacy Policy', '/policies/privacy-policy'],
        ['Refund Policy', '/policies/refund-policy'],
        ['Shipping Policy', '/policies/shipping-policy'],
        ['Terms of Service', '/policies/terms-of-service']
      ],
      cta: ['Site Map', '/pages/sitemap']
    }
  ];

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function build() {
    var wrap = el('div', 'wg-res');

    GROUPS.forEach(function (g, i) {
      if (i > 0) wrap.appendChild(el('div', 'wg-res__rule'));

      var sec = el('div', 'wg-res__g');
      sec.appendChild(el('p', 'wg-res__label', g.label));

      g.links.forEach(function (l) {
        var a = el('a', 'wg-res__link', l[0]);
        a.href = l[1];
        sec.appendChild(a);
      });

      if (g.cta) {
        var c = el('a', 'wg-res__cta', g.cta[0]);
        c.href = g.cta[1];
        c.appendChild(el('span', 'wg-res__chev', '›'));
        sec.appendChild(c);
      }

      wrap.appendChild(sec);
    });

    return wrap;
  }

  /* The accordion is found by its visible title, not by a class or an index -
     block ids and ordering change every time the menu is edited in Customize,
     a title does not. */
  function panel() {
    var titles = document.querySelectorAll('.nm-row-title');
    for (var i = 0; i < titles.length; i++) {
      if (titles[i].textContent.trim().toLowerCase() !== 'resources') continue;
      var det = titles[i].closest('details.nm-acc');
      if (det) return det;
    }
    return null;
  }

  function apply() {
    var det = panel();
    if (!det || det.getAttribute('data-wg-res') === '1') return !!det;

    var body = det.querySelector('.nm-acc-body');
    if (!body) return false;

    body.textContent = '';
    body.classList.add('wg-res-host');
    body.appendChild(build());

    /* The microgreens view-all sat outside .nm-acc-body, as a sibling. */
    var viewAll = det.querySelector('.nm-dd-viewall');
    if (viewAll) viewAll.remove();

    det.setAttribute('data-wg-res', '1');
    return true;
  }

  function start() {
    if (apply()) return;

    /* The drawer is built after first paint, and the header re-renders it when
       a tab is switched, so watch rather than run once. */
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (apply() || tries > 40) clearInterval(t);
    }, 250);

    new MutationObserver(function () { apply(); })
      .observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
